"use strict";
/**
 * @note These payment APIs for candyShop only allow the shopId & token in allowlist to call.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandyShopPay = void 0;
const PaymentAPI_1 = require("./factory/backend/PaymentAPI");
const config_1 = __importDefault(require("./vendor/config"));
class CandyShopPay {
    static checkPaymentAvailability(params) {
        return (0, PaymentAPI_1.checkPaymentAvailability)(config_1.default, params);
    }
    static createPayment(params) {
        return (0, PaymentAPI_1.createPaymentIntents)(config_1.default, params);
    }
    static confirmPayment(params) {
        return (0, PaymentAPI_1.confirmPaymentIntents)(config_1.default, params);
    }
    static getTokenFiatMoneyPrice(params, quotePriceQuery) {
        return (0, PaymentAPI_1.fetchTokenFiatMoneyPrice)(config_1.default, params, quotePriceQuery);
    }
}
exports.CandyShopPay = CandyShopPay;
